import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { AIP_DOMAIN } from '@/constants/api';
import { getEncryptedHeader } from './SymmetricEncryption';
export async function axiosGet({
  url,
  config,
  domain,
  jwtToken,
}: {
  url: string;
  config?: AxiosRequestConfig;
  domain?: string;
  jwtToken?: string;
}): Promise<AxiosResponse> {
  // need move params to url for encrypted

  if (config?.params) {
    const pa = new URLSearchParams(config.params);
    pa.sort();
    const params = pa.toString();
    url += (url.includes('?') ? '&' : '?') + params;
    config.params = undefined;
  }
  const encryptedData = getEncrypted({ url, jwtToken, domain });
  if (encryptedData?.url) {
    url = encryptedData.url;
  }

  return await axios.get(url, {
    ...config,
    headers: {
      ...config?.headers,
      Authorization: jwtToken,
      ...encryptedData?.encryptedData,
    },
  });
}
export async function axiosPost({
  url,
  data,
  config,
  domain,
  jwtToken,
}: {
  url: string;
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  data?: any;
  config?: AxiosRequestConfig;
  domain?: string;
  jwtToken?: string;
}): Promise<AxiosResponse> {
  const encryptedData = getEncrypted({ url, jwtToken, body: data, domain });
  if (encryptedData?.url) {
    url = encryptedData.url;
  }
  return await axios.post(url, data, {
    ...config,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      ...config?.headers,
      Authorization: jwtToken,
      ...encryptedData?.encryptedData,
    },
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getEncrypted({
  url,
  jwtToken,
  body,
  domain,
}: {
  url: string;
  jwtToken?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  domain?: string;
}) {
  if (!domain) domain = AIP_DOMAIN;
  if (!url.startsWith('http')) {
    if (!url.startsWith('/')) {
      url = '/' + url;
    }
    url = domain + url;
  }

  if (url.startsWith(domain)) {
    const uri = url.replace(domain, '');
    const encryptedHeader = getEncryptedHeader({
      uri,
      authorization: jwtToken,
      body: body,
    });

    return { encryptedData: encryptedHeader, url };
  }
}
